/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CompletePlaidLinkRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/PlaidBankLinking.pb'
import {CompletePlaidLinkResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/PlaidBankLinking.pb'


export const plaidBankLinking = (request: CompletePlaidLinkRequest, options?: CashRequestOptions) => post<CompletePlaidLinkRequest, CompletePlaidLinkResponse>("/2.0/cash/plaid-bank-linking", request, {...options, rejectOnError: true })